document.addEventListener('DOMContentLoaded', () => {
    const windowHeight = window.innerHeight;

    if(document.querySelector('.jsHeader')){
        window.header = {
            main: document.querySelector('.jsHeader'),
            nav: {
                trigger: document.querySelector('.jsNavTrigger'),
                dropdown: document.querySelector('.jsNavDropdown'),
            },
            logo: document.querySelector('.jsHeaderLogo'),
            search: {
                main: document.querySelector('.jsSearch'),
                trigger: document.querySelector('.jsSearchButton'),
                open: () => {
                    window.header.search.main.classList.add('is-open');
                    window.header.logo.classList.add('is-hide')
                },
                close: () => {
                    window.header.search.main.classList.remove('is-open');
                    window.header.logo.classList.remove('is-hide')
                }
            },
            burger: {
                trigger: document.querySelector('.jsBurgerTrigger'),
                
                toggle: () => {
                    window.header.main.classList.toggle('is-active')
                    window.header.burger.trigger.classList.toggle('is-active')
                    document.querySelector('body').classList.toggle('_lock');
                },
            }, 
        };

        window.header.search.trigger.addEventListener('click', (e) => {
            if(window.innerWidth <= 1024) {
                if(!window.header.search.main.classList.contains('is-open')){
                    e.preventDefault()
                    window.header.search.open()
                } else{
                    window.header.search.close()
                }
            }
        })

        window.header.burger.trigger.addEventListener('click', () => {
            window.header.burger.toggle()
        })

        window.header.nav.trigger.addEventListener('click', () => {
            window.header.nav.trigger.classList.toggle('is-active')
            window.header.nav.dropdown.classList.toggle('is-active')
        })

 
        document.addEventListener('click', (e) => {
            const target = e.target 
            if (window.header.main.classList.contains('is-active') && !target.closest('.jsHeader')) {
                window.header.burger.toggle()
            }

            if (window.header.search.main.classList.contains('is-open') && !target.closest('.jsSearch')) {
                window.header.search.close()
            }
        })

        document.addEventListener('scroll', () => {
            if(window.pageYOffset >= (windowHeight * 0.25)){
                window.header.main.classList.add('is-fixed')
            } else{
                window.header.main.classList.remove('is-fixed')
            }
        })

        if(document.querySelector('.jsMove')){
            let moveItems = document.querySelectorAll('.jsMove');

            function move(mode){
                                
                for (let index = 0; index < moveItems.length; index++) {
                    let item = moveItems[index];
                    let desktop = item.getAttribute('data-move-desktop');
                    let mobile = item.getAttribute('data-move-mobile');

                    if (mode == 'desktop'){
                        document.querySelector('[data-move-container="'+ desktop +'"]').append(item)
                    }

                    if (mode == 'mobile'){
                        document.querySelector('[data-move-container="'+ mobile +'"]').append(item)
                    }
                }
            }
                    
            if (window.innerWidth <= 1024) {
                move('mobile');
            } else {
                move('desktop');
            }

            let windowWidth = window.innerWidth;
            let savedWindowWidth = windowWidth;
        
            window.addEventListener("resize", () => {
                windowWidth = window.innerWidth;

                if (savedWindowWidth == windowWidth){
                    return;
                }

                if(savedWindowWidth != windowWidth) {
                    savedWindowWidth = windowWidth;
                    if (window.innerWidth <= 1024) {
                        move('mobile');
                    } else {
                        move('desktop');
                    }
                }
            });
        }

        if(document.querySelector('.jsNav')) {
            let nav = document.querySelector('.jsNav');
            let list = nav.querySelector('.nav');
            let items = list.querySelectorAll('.nav__item');
            let dropdown = document.querySelector('.jsNavDropdown');
            let dropdownInner = dropdown.querySelector('.nav__dropdown-inner');
            let trigger = document.querySelector('.jsNavTrigger');
        
            function check(){
                let dropdownLast = dropdownInner.querySelectorAll('.nav__item')[dropdownInner.querySelectorAll('.nav__item').length - 1] ? dropdownInner.querySelectorAll('.nav__item')[dropdownInner.querySelectorAll('.nav__item').length - 1] : '';

                if (nav.offsetWidth < list.offsetWidth) {
                    // console.log('hide ' + nav.offsetWidth +' ; ' + Number(list.offsetWidth));
                    hide()
                } else if (nav.offsetWidth >= Number(list.offsetWidth + dropdownLast.offsetWidth + 32)){
                    // console.log('show ' + nav.offsetWidth +' >= ' + list.offsetWidth + ' + ' + dropdownLast.offsetWidth + ' + ' + 32 + ' = ' + Number(list.offsetWidth + dropdownInner.querySelectorAll('.nav__item')[dropdownInner.querySelectorAll('.nav__item').length - 1].offsetWidth + 32));
                    show()
                }

                if (dropdownInner.querySelector('.nav__item')){
                    trigger.classList.add('is-visible');
                } else{
                    trigger.classList.remove('is-visible');
                }
            }
        
            function hide(){
                items = list.querySelectorAll('.nav__item');
                dropdownInner.append(items[items.length - 1])
        
                check()
            }
        
            function show(){
                let dItems = dropdownInner.querySelectorAll('.nav__item');
                trigger.before(dItems[dItems.length - 1])
        
                check()
            }
        
            function mobile(){
                if(dropdownInner.querySelector('.nav__item')){
                    let dItems = dropdownInner.querySelectorAll('.nav__item');
        
                    for (let index = 0; index < dItems.length; index++) {
                        const item = dItems[index];
                        trigger.before(item)
                    }
                }
            }
        
            if (window.innerWidth >= 1024) {
                check()
            } else {
                mobile()
            }

            let windowWidth = window.innerWidth;
            let savedWindowWidth = windowWidth;
        
            window.addEventListener("resize", () => {
                windowWidth = window.innerWidth;

                if (savedWindowWidth == windowWidth){
                    return;
                }

                if(savedWindowWidth != windowWidth) {
                    savedWindowWidth = windowWidth;

                    if (window.innerWidth >= 1024){
                        check()
                    } else{
                        mobile()
                    }
                }
            });
        }
    }
})
